<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="7" class="px-10 text-center">
                    <h1 class="text-h3 font-weight-bold mb-15">We're on a Panel!</h1>
                    <h1 class="text-h1 mb-5">ICTSS 1705</h1>
                    <h3 class="text-h5 mb-8">Telecommunications: Data, Voice, Mobile, Video, Unified Comms Solutions</h3>
                    <div class="d-flex justify-center mb-8"><hr/></div>
                    <p> 
                        Procurement made simple. Being on the panel means agencies can engage Yabbr quickly, securely, and with confidence.
                    </p>
                    
                    
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'GovPanel',
}
</script>

<style lang="scss">


hr {
    margin: 1em 0;
    width: 50%;
}
</style>